import toast from 'react-hot-toast';
import API from './api';

// the public website: localhost while developing, the real site everywhere else
const WEBSITE_URL = ['localhost', '127.0.0.1'].includes(window.location.hostname)
    ? 'http://localhost:3000'
    : 'https://gettimelammatrimony.com';

/**
 * Opens the website signed in as a member / service provider for 30 minutes ("Login as").
 * The new tab is opened first (so the browser does not block it), then pointed at the website's /impersonate page.
 * The token travels in the part of the address after "#", which is never sent to any server or written to a server log.
 */
export const openAccountAsAdmin = async (accountId) => {
    const tab = window.open('about:blank', '_blank');
    try {
        const { data } = await API.post(`/admin/users/${accountId}/impersonate`);
        const hash = new URLSearchParams({
            token: data.token, role: data.role, name: data.name || '', until: String(new Date(data.expiresAt).getTime()),
        }).toString();
        const url = `${WEBSITE_URL}/impersonate#${hash}`;
        if (tab) tab.location.href = url;
        else window.open(url, '_blank');
        toast.success(`Opened ${data.name || 'the account'} for ${data.minutes} minutes`);
    } catch (error) {
        if (tab) tab.close();
        toast.error(error.response?.data?.message || 'Could not open this account');
    }
};
